export default __webpack_public_path__ + "static/media/4.87e05dc3.webp";